.container {
	color: var(--ds-text-disabled, var(--adg3-color-N70));
	height: 40px;
	display: flex;
	align-items: center;
	padding-left: calc(var(--jpo-common-base-spacing) * 1.75);
	white-space: nowrap;
}
